import React, { useEffect, useRef, useState } from "react";
import styles from "./SectionHome3Carrousel.module.scss";
import {
  Swiper,
  SwiperSlide,
} from "../../../node_modules/swiper/react/swiper-react.js";
import { Pagination } from "swiper";
import "../../../node_modules/swiper/swiper.scss";
import "../../../node_modules/swiper/modules/navigation/navigation.scss"; // Navigation module
import "../../../node_modules/swiper/modules/effect-cards/effect-cards.scss"; // Pagination module
import "../../../node_modules/swiper/modules/effect-creative/effect-creative.scss"; // Pagination module
import "../../../node_modules/swiper/modules/autoplay/autoplay.scss"; // Pagination module
import ShopIcon from "../../components/icons/ShopIcon";
import { useNavigate } from "react-router-dom";
import ModalPointerHome from "./ModalPointerHome.jsx";

const SectionHome3Mobile = () => {
  const [open, setOpen] = useState(false);
  const slides = [
    {
      index: 0,
      img: "/homepage/FancyMonas-cuadro-mobile.png",
      class: "one",
      onclick: () => setOpen(!open),
    },
    { index: 1, img: "/homepage/FancyMonas-x9-mobile.png", class: "two" },
    {
      index: 2,
      img: "/homepage/FancyMonas-detalle-mobile.png",
      class: "three",
    },
  ];
  const [content, setContent] = useState(0);
  const swiperRef = useRef(null);
  const paginationRef = useRef(null);
  const navigate = useNavigate();
  /* const { refs, floatingStyles, context } = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [offset(8), flip(), shift()],
    whileElementsMounted: autoUpdate,
    placement: "bottom",
  }); */

  // Maneja los eventos: click dentro/fuera
  /* const click = useClick(context);
  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
  ]);
 */
  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const params = {
    pagination: {
      el: ".custom-pagination-home-mobile",
      clickable: true,
    },
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params) {
      swiperRef.current.params.pagination.el = paginationRef.current;
      swiperRef.current.pagination.init();
      swiperRef.current.pagination.render();
      swiperRef.current.pagination.update();
    }
  }, []);

  /*   const handleClick = (index) => {
    setContent(index); // o un objeto con datos si prefieres
    setOpen(!open); // abre el popover
  };
 */
  return (
    <>
      <div id="sectionHome3CarrouselMobile" className={styles.WrapperMobile}>
        {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "2rem",
            width: "100%",
          }}
        >
          <div className={styles.buttonPrevMobile} onClick={goPrev}>
            <SliderArrowLeft />
          </div>
          <div className={styles.buttonNextMobile} onClick={goNext}>
            <SldierArrowRight />
          </div>
        </div> */}
        <Swiper
          ref={swiperRef}
          slidesPerView={1}
          centeredSlides={true}
          modules={[Pagination]}
          className="swiperMobile"
          {...params}
        >
          {slides.map((m) => (
            <SwiperSlide key={m.index} className={m.class}>
              <img
                className={`${styles.imageSlider} ${
                  m.index === 0 && styles.one
                }`}
                src={m.img}
                alt={`mona-${m.index}`}
                onClick={m.onclick}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="custom-pagination-home-mobile"></div>
        <h2 className={styles.callActionMobile}>Elegí tu FANCY MONA</h2>
        <button
          className={styles.buttonShopMobile}
          onClick={() => navigate("/collection")}
        >
          <ShopIcon />
          SHOP
        </button>
        {/* {open && (
          <div
            ref={refs.setFloating}
            style={{
              ...floatingStyles,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              padding: "8px 12px",
              borderRadius: "6px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              zIndex: 100,
            }}
            {...getFloatingProps()}
          >
            {content === 0 && <p>Este es el contenido para el index 1</p>}
            {content === 1 && <p>Este es el contenido para el index 2</p>}
            {content === 2 && <p>Este es el contenido para el index 3</p>}
            {content === 3 && <p>Este es el contenido para el index 4</p>}
          </div>
        )} */}
        {open && (
          <ModalPointerHome open={open} onClose={() => setOpen(false)} />
        )}
      </div>
    </>
  );
};

export default SectionHome3Mobile;
